export default "__VITE_ASSET__07d78f13__"